module.exports = __webpack_public_path__ + "media/src/assets/images/lps-secondcarrier-11bbb2edd4b65e0e276584ec02264d51.png";